import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger } from '../utils';

export const savedShippingAddressDropdownOpenedConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.SAVED_SHIPPING_ADDRESS_DROPDOWN_OPENED,
  handler: ({ detail }) => {
    logger('Saved Shipping Address Dropdown Opened');
    console.log(detail);
  },
};
